import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { UserProfile } from "../../models/user-profile/user-profile.model";

@Injectable({
    providedIn: 'root'
})
export class UserProfileService {

    constructor(private http: HttpClient) {}

    getProfileByGuid(userProfileGuid: string): Observable<{ userProfile: UserProfile }> {
        const url = `${environment.user.root}/${userProfileGuid}`;
        return this.http.get<{ userProfile: UserProfile }>(url, { withCredentials: true });
    }

    updateProfile(userProfileGuid: string, payload: Partial<UserProfile>): Observable<{ userProfile: UserProfile }> {
        const url = `${environment.user.root}/${userProfileGuid}`;
        return this.http.put<{ userProfile: UserProfile }>(url, payload, { withCredentials: true });
    }

    uploadAvatar(userProfileGuid: string, file: File): Observable<{ userProfile: UserProfile }> {
        const formData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<{ userProfile: UserProfile }>(
            environment.user.avatar(userProfileGuid),
            formData,
            { withCredentials: true }
        );
    }
}
